<template class="compare">
  <div class="table">
    <span
      v-if="formData.class_id == 14"
      class="compare">
      <div class="tr">
        <span>ls this Vehicle registered under the applicant now ?</span>
        <span v-if="formData.already_owned_by_ind === oldForm.already_owned_by_ind">{{ getOptionName('yesNoOptions', formData.already_owned_by_ind)}}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ getOptionName('yesNoOptions', oldForm.already_owned_by_ind) }}</span>
          <span class="color-success">{{ getOptionName('yesNoOptions', formData.already_owned_by_ind) }}</span>
        </span>
      </div>
      <div
        class="tr">
        <span>Registration Mark</span>
        <span v-if="formData.rgtn_no === oldForm.rgtn_no">{{ formData.rgtn_no }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ oldForm.rgtn_no }}</span>
          <span class="color-success">{{ formData.rgtn_no }}</span>
        </span>
      </div>
      <div class="tr">
        <span>Coverage</span>
        <span>{{getOptionName('allCoverTypeOptions', formData.trm_of_cvr)  }}</span>
      </div>
      <div class="tr">
        <span>Car Type</span>
        <span v-if="formData.class_id === oldForm.class_id">{{ getOptionName('classOptions', classId) }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ getOptionName('classOptions', oldForm.class_id) }}</span>
          <span class="color-success">{{ getOptionName('classOptions', formData.class_id)}}</span>
        </span>
      </div>
      <div class="tr">
        <span>Make</span>
        <span v-if="formData.brand_id === oldForm.brand_id">{{ formData.brand }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ oldForm.brand }}</span>
          <span class="color-success">{{ getLocalAllOptionName('brand', formData.brand_id)}}</span>
        </span>
      </div>
      <div class="tr">
        <span>Model</span>
        <span v-if="formData.rgtn_mdl === oldForm.rgtn_mdl">{{ formData.rgtn_mdl }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ oldForm.rgtn_mdl }}</span>
          <span class="color-success">{{ formData.rgtn_mdl}}</span>
        </span>
      </div>
      <div class="tr">
        <span>Body Type</span>
        <span v-if="formData.typ_of_bdy_id === oldForm.typ_of_bdy_id">{{ getLocalAllOptionName('typ_of_bdy', formData.typ_of_bdy_id) }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ getLocalAllOptionName('typ_of_bdy', oldForm.typ_of_bdy_id) }}</span>
          <span class="color-success">{{ getLocalAllOptionName('typ_of_bdy', formData.typ_of_bdy_id) }}</span>
        </span>
      </div>
      <div class="tr">
        <span>Year of Manufacture</span>
        <span v-if="formData.rgtn_yr === oldForm.rgtn_yr">{{ getLocalAllOptionName('rgtn_yr', formData.rgtn_yr) }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ getLocalAllOptionName('rgtn_yr', oldForm.rgtn_yr) }}</span>
          <span class="color-success">{{ getLocalAllOptionName('rgtn_yr', formData.rgtn_yr) }}</span>
        </span>
      </div>
      <div class="tr">
        <span>Cylinder Capacity (Input "0" for EV)</span>
        <span v-if="formData.engn_cpcty== oldForm.engn_cpcty">{{ formData.engn_cpcty }} cc</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ oldForm.engn_cpcty }} cc</span>
          <span class="color-success">{{ formData.engn_cpcty }} cc</span>
        </span>
      </div>
      <div class="tr">
        <span>Seating Capacity ( excl. driver)</span>
        <span v-if="formData.no_of_seats== oldForm.no_of_seats">{{ formData.no_of_seats }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ oldForm.no_of_seats }}</span>
          <span class="color-success">{{ formData.no_of_seats }}</span>
        </span>
      </div>
      <div class="tr">
        <span>Chassis Number</span>
        <span v-if="formData.chasis_no === oldForm.chasis_no">{{ formData.chasis_no }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ oldForm.chasis_no }}</span>
          <span class="color-success">{{ formData.chasis_no }}</span>
        </span>
      </div>
      <div class="tr">
        <span>Engine Number</span>
        <span v-if="formData.engn_no === oldForm.engn_no">{{ formData.engn_no }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ oldForm.engn_no }}</span>
          <span class="color-success">{{ formData.engn_no }}</span>
        </span>
      </div>
      <div class="tr">
        <span>NCD</span>
        <span v-if="formData.ncd_pct === oldForm.ncd_pct">{{ getLocalAllOptionName('ncd', formData.ncd_pct) }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ getLocalAllOptionName('ncd', oldForm.ncd_pct) }}</span>
          <span class="color-success">{{ getLocalAllOptionName('ncd', formData.ncd_pct) }}</span>
        </span>
      </div>
      <div v-if="formData.ncd_pct>0">
        <div class="tr">
          <span>Previous Insurance Company</span>
          <span v-if="formData.prev_insurer_nm === oldForm.prev_insurer_nm">{{formData.prev_insurer_nm_language}}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{  oldForm.prev_insurer_nm_language}}</span>
            <span class="color-success">{{ getLocalAllOptionName('globalOptions.latest_insurance_company', formData.prev_insurer_nm) }}</span>
          </span>
        </div>
        <div class="tr">
          <span>Previous Registration Number</span>
          <span v-if="formData.prev_rgtn_no === oldForm.prev_rgtn_no">{{formData.prev_rgtn_no}}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{  oldForm.prev_rgtn_no }}</span>
            <span class="color-success">{{ formData.prev_rgtn_no }}</span>
          </span>

        </div>
        <div class="tr">
          <span>Previous Policy Number</span>

          <span v-if="formData.prev_pcy_no === oldForm.prev_pcy_no">{{ formData.prev_pcy_no }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{  oldForm.prev_pcy_no }}</span>
            <span class="color-success">{{ formData.prev_pcy_no }}</span>
          </span>
        </div>
        <div class="tr">
          <span>Is the subject Insured vehicle be the same as the one under the previous policy?</span>

          <span v-if="formData.is_same_car === oldForm.is_same_car">{{  getOptionName('yesNoOptions', formData.is_same_car)  }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{  getOptionName('yesNoOptions', oldForm.is_same_car)  }}</span>
            <span class="color-success">{{  getOptionName('yesNoOptions', formData.is_same_car)  }}</span>
          </span>
        </div>
        <!--        <div-->
        <!--          v-if="showAgreeQusetion"-->
        <!--          class="tr">-->
        <!--          <span>As you are the existing client of the selected insurance company, due to the administration requirement, you agree to appoint HoldCover Insurance Brokers Limited to handle the insurance matter with immediate effect, and understand that the policy documents will be ready in 3-5 working days.</span>-->

        <!--          <span v-if="formData.is_agree_handle === oldForm.is_agree_handle">{{  getOptionName('agreeOptions', formData.is_agree_handle)  }}</span>-->
        <!--          <span-->
        <!--            v-else-->
        <!--            class="compare">-->
        <!--            <span class="text-line color-danger">{{  getOptionName('agreeOptions', oldForm.is_agree_handle)  }}</span>-->
        <!--            <span class="color-success">{{  getOptionName('agreeOptions', formData.is_agree_handle)  }}</span>-->
        <!--          </span>-->
        <!--        </div>-->
      </div>
      <div class="tr">
        <span>Insurance Type</span>
        <span v-if="formData.trm_of_cvr === oldForm.trm_of_cvr">{{ getOptionName('coverTypeOptions', formData.trm_of_cvr) }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ getOptionName('coverTypeOptions', oldForm.trm_of_cvr) }}</span>
          <span class="color-success">{{ getOptionName('coverTypeOptions', formData.trm_of_cvr) }}</span>
        </span>
      </div>
      <div class="tr">
        <span>Is there any modification in the above vehicle</span>
        <span
          v-if="formData.car_modified_ind === oldForm.car_modified_ind">{{ getOptionName('yesNoOptions', formData.car_modified_ind) }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ getOptionName('yesNoOptions', oldForm.car_modified_ind) }}</span>
          <span class="color-success">{{ getOptionName('yesNoOptions', formData.car_modified_ind) }}</span>
        </span>
      </div>
      <div
        v-if="formData.class_id==11||formData.class_id==12"
        class="tr">
        <span>Alarm and / or Global Positioning System should be installed?</span>
        <span
          v-if="formData.alarm_or_global_ind === oldForm.alarm_or_global_ind"
          class="red">{{ getOptionName('yesNoOptions', formData.alarm_or_global_ind) }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ getOptionName('yesNoOptions', oldForm.alarm_or_global_ind) }}</span>
          <span class="color-success">{{ getOptionName('yesNoOptions', formData.alarm_or_global_ind) }}</span>
        </span>
      </div>
      <div class="tr">
        <span>Will the vehicle be used for commercial purpose?</span>
        <span v-if="formData.usage_ind === oldForm.usage_ind">{{ getAllOptionName('mc_usage', formData.usage_ind) }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{getAllOptionName('mc_usage', oldForm.usage_ind) }}</span>
          <span class="color-success">{{getAllOptionName('mc_usage',formData.usage_ind)}}</span>
        </span>
      </div>
      <!--      <div class="tr">-->
      <!--        <span>What kind of commercial usage?</span>-->
      <!--        &lt;!&ndash; <span>In addition to social, domestic, pleasure use and by the proposer for business purposes, will the vehicle be used for</span> &ndash;&gt;-->
      <!--        <span-->
      <!--          v-if="compareBusinessPurposes"-->
      <!--          class="compare">-->
      <!--          <span-->
      <!--            v-if="businessPurposes.length>0"-->
      <!--            class="child-span-block">-->
      <!--            <span-->
      <!--              v-for="(item, index) in businessPurposes"-->
      <!--              :key="index"-->
      <!--              class="red">-->
      <!--              {{ item.name }}-->
      <!--            </span>-->
      <!--          </span>-->
      <!--          <span v-else>None</span>-->
      <!--        </span>-->
      <!--        <span-->
      <!--          v-else-->
      <!--          class="compare">-->
      <!--          <span-->
      <!--            v-if="oldBusinessPurposes.length>0"-->
      <!--            class="child-span-block">-->
      <!--            <span-->
      <!--              v-for="(item, index) in oldBusinessPurposes"-->
      <!--              :key="index"-->
      <!--              class="red text-line color-danger">-->
      <!--              {{ item.name }}-->
      <!--            </span>-->
      <!--          </span>-->
      <!--          <span-->
      <!--            v-else-->
      <!--            class="text-line color-danger">None</span>-->
      <!--          <span-->
      <!--            v-if="businessPurposes.length>0"-->
      <!--            class="child-span-block">-->
      <!--            <span-->
      <!--              v-for="(item, index) in businessPurposes"-->
      <!--              :key="index"-->
      <!--              class="color-success">-->
      <!--              {{ item.name }}-->
      <!--            </span>-->
      <!--          </span>-->
      <!--          <span-->
      <!--            v-else-->
      <!--            class="color-success">None</span>-->
      <!--        </span>-->
      <!--      </div>-->
      <div class="tr">
        <span>Is the vehicle fitted with Car Camcorder?</span>
        <span v-if="formData.car_camcorder_ind === oldForm.car_camcorder_ind">{{ getOptionName('yesNoOptions', formData.car_camcorder_ind) }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ getOptionName('yesNoOptions', oldForm.car_camcorder_ind) }}</span>
          <span class="color-success">{{ getOptionName('yesNoOptions', formData.car_camcorder_ind) }}</span>
        </span>
      </div>
    </span>
    <span
      v-else
      class="compare">
      <div class="tr">
        <span>Is this Vehicle already owned by the applicant now?</span>
        <span v-if="formData.already_owned_by_ind === oldForm.already_owned_by_ind">{{ getOptionName('yesNoOptions', formData.already_owned_by_ind)}}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ getOptionName('yesNoOptions', oldForm.already_owned_by_ind) }}</span>
          <span class="color-success">{{ getOptionName('yesNoOptions', formData.already_owned_by_ind) }}</span>
        </span>
      </div>
      <div
        class="tr">
        <span>Registration Mark</span>
        <span v-if="formData.rgtn_no === oldForm.rgtn_no">{{ formData.rgtn_no }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ oldForm.rgtn_no }}</span>
          <span class="color-success">{{ formData.rgtn_no }}</span>
        </span>
      </div>
      <div class="tr">
        <span>Coverage</span>
        <span>{{getOptionName('allCoverTypeOptions', formData.trm_of_cvr)  }}</span>
      </div>
      <div class="tr">
        <span>Year of Manufacture</span>
        <span v-if="formData.rgtn_yr === oldForm.rgtn_yr">{{ getLocalAllOptionName('rgtn_yr', formData.rgtn_yr) }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ getLocalAllOptionName('rgtn_yr', oldForm.rgtn_yr) }}</span>
          <span class="color-success">{{ getLocalAllOptionName('rgtn_yr', formData.rgtn_yr) }}</span>
        </span>
      </div>
      <div class="tr">
        <span>Make</span>
        <span v-if="formData.brand_id === oldForm.brand_id">{{ formData.brand }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ oldForm.brand }}</span>
          <span class="color-success">{{ getLocalAllOptionName('brand', formData.brand_id)}}</span>
        </span>
      </div>
      <div
        v-if="classId == 12"
        class="tr">
        <span>Model</span>
        <span v-if="formData.rgtn_mdl === oldForm.rgtn_mdl">{{ formData.rgtn_mdl }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ oldForm.rgtn_mdl }}</span>
          <span class="color-success">{{ formData.rgtn_mdl}}</span>
        </span>
      </div>
      <div
        v-else
        class="tr">
        <span>Model</span>
        <span v-if="formData.model_id === oldForm.model_id">{{ getOptionName('carModelOptions', formData.model_id) }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ getOptionName('carModelOptions', oldForm.model_id) }}</span>
          <span class="color-success">{{ getOptionName('carModelOptions', formData.model_id) }}</span>
        </span>
      </div>
      <div
        v-if="classId==11"
        class="tr">
        <span>Model Name</span>
        <span v-if="formData.rgtn_mdl === oldForm.rgtn_mdl">{{ formData.rgtn_mdl }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ oldForm.rgtn_mdl }}</span>
          <span class="color-success">{{ formData.rgtn_mdl }}</span>
        </span>
      </div>
      <div class="tr">
        <span>Body Type</span>
        <span v-if="formData.typ_of_bdy_id === oldForm.typ_of_bdy_id">{{ getLocalAllOptionName('typ_of_bdy', formData.typ_of_bdy_id) }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ getLocalAllOptionName('typ_of_bdy', oldForm.typ_of_bdy_id) }}</span>
          <span class="color-success">{{ getLocalAllOptionName('typ_of_bdy', formData.typ_of_bdy_id) }}</span>
        </span>
      </div>
      <div
        v-if="classId==12||classId==11&&!isElectricCar11"
        class="tr">
        <span>Cylinder Capacity (Input "0" for EV)</span>
        <span v-if="formData.engn_cpcty== oldForm.engn_cpcty">{{ formData.engn_cpcty }} cc</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ oldForm.engn_cpcty }} cc</span>
          <span class="color-success">{{ formData.engn_cpcty }} cc</span>
        </span>
      </div>
      <div class="tr">
        <span>NCD</span>
        <span v-if="formData.ncd_pct === oldForm.ncd_pct">{{ getLocalAllOptionName('ncd', formData.ncd_pct) }}</span>
        <span
          v-else
          class="compare">
          <span class="text-line color-danger">{{ getLocalAllOptionName('ncd', oldForm.ncd_pct) }}</span>
          <span class="color-success">{{ getLocalAllOptionName('ncd', formData.ncd_pct) }}</span>
        </span>
      </div>
      <div v-if="formData.ncd_pct>0">
        <div class="tr">
          <span>Previous Insurance Company</span>
          <span v-if="formData.prev_insurer_nm === oldForm.prev_insurer_nm">{{formData.prev_insurer_nm_language}}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{ oldForm.prev_insurer_nm_language }}</span>
            <span class="color-success">{{ getLocalAllOptionName('globalOptions.latest_insurance_company', formData.prev_insurer_nm) }}</span>
          </span>
        </div>
        <div class="tr">
          <span>Previous Registration Number</span>
          <span v-if="formData.prev_rgtn_no === oldForm.prev_rgtn_no">{{ formData.prev_rgtn_no }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{  oldForm.prev_rgtn_no }}</span>
            <span class="color-success">{{ formData.prev_rgtn_no }}</span>
          </span>

        </div>
        <div class="tr">
          <span>Previous Policy Number</span>

          <span v-if="formData.prev_pcy_no === oldForm.prev_pcy_no"></span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{  oldForm.prev_pcy_no }}</span>
            <span class="color-success">{{ formData.prev_pcy_no }}</span>
          </span>
        </div>
        <div class="tr">
          <span>Is the subject Insured vehicle be the same as the one under the previous policy?</span>

          <span v-if="formData.is_same_car === oldForm.is_same_car">{{  getOptionName('yesNoOptions', formData.is_same_car)  }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{  getOptionName('yesNoOptions', oldForm.is_same_car)  }}</span>
            <span class="color-success">{{  getOptionName('yesNoOptions', formData.is_same_car)  }}</span>
          </span>
        </div>
        <!--        <div-->
        <!--          v-if="showAgreeQusetion"-->
        <!--          class="tr">-->
        <!--          <span>As you are the existing client of the selected insurance company, due to the administration requirement, you agree to appoint HoldCover Insurance Brokers Limited to handle the insurance matter with immediate effect, and understand that the policy documents will be ready in 3-5 working days.</span>-->

        <!--          <span v-if="formData.is_agree_handle === oldForm.is_agree_handle">{{  getOptionName('agreeOptions', formData.is_agree_handle)  }}</span>-->
        <!--          <span-->
        <!--            v-else-->
        <!--            class="compare">-->
        <!--            <span class="text-line color-danger">{{  getOptionName('agreeOptions', oldForm.is_agree_handle)  }}</span>-->
        <!--            <span class="color-success">{{  getOptionName('agreeOptions', formData.is_agree_handle)  }}</span>-->
        <!--          </span>-->
        <!--        </div>-->
      </div>
      <section v-if="classId == 11">
        <div
          class="tr">
          <span>Seating Capacity ( excl. driver)</span>
          <span v-if="formData.no_of_seats== oldForm.no_of_seats">{{ formData.no_of_seats }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{ oldForm.no_of_seats }}</span>
            <span class="color-success">{{ formData.no_of_seats }}</span>
          </span>
        </div>
        <div class="tr">
          <span>Chassis Number</span>
          <span v-if="formData.chasis_no === oldForm.chasis_no">{{ formData.chasis_no }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{ oldForm.chasis_no }}</span>
            <span class="color-success">{{ formData.chasis_no }}</span>
          </span>
        </div>
        <div class="tr">
          <span>Engine Number</span>
          <span v-if="formData.engn_no === oldForm.engn_no">{{ formData.engn_no }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{ oldForm.engn_no }}</span>
            <span class="color-success">{{ formData.engn_no }}</span>
          </span>
        </div>
        <div class="tr">
          <span>Car Usage</span>
          <span v-if="formData.usage_ind === oldForm.usage_ind">{{ getOptionName('usageOptions', formData.usage_ind) }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{ getOptionName('usageOptions', oldForm.usage_ind) }}</span>
            <span class="color-success">{{ getOptionName('usageOptions', formData.usage_ind)}}</span>
          </span>
        </div>

        <div class="tr">
          <span>What kind of commercial usage?</span>
          <!-- <span>In addition to social, domestic, pleasure use and by the proposer for business purposes, will the vehicle be used for</span> -->
          <span
            v-if="compareBusinessPurposes"
            class="compare">
            <span
              v-if="businessPurposes.length>0"
              class="child-span-block">
              <span
                v-for="(item, index) in businessPurposes"
                :key="index"
                class="red">
                {{ item.name }}
              </span>
            </span>
            <span v-else>None</span>
          </span>
          <span
            v-else
            class="compare">
            <span
              v-if="oldBusinessPurposes.length>0"
              class="child-span-block">
              <span
                v-for="(item, index) in oldBusinessPurposes"
                :key="index"
                class="red text-line color-danger">
                {{ item.name }}
              </span>
            </span>
            <span
              v-else
              class="text-line color-danger">None</span>
            <span
              v-if="businessPurposes.length>0"
              class="child-span-block">
              <span
                v-for="(item, index) in businessPurposes"
                :key="index"
                class="color-success">
                {{ item.name }}
              </span>
            </span>
            <span
              v-else
              class="color-success">None</span>
          </span>
        </div>
        <div class="tr">
          <span>Is there any modification in the above vehicle</span>
          <span
            v-if="formData.car_modified_ind === oldForm.car_modified_ind">{{ getOptionName('modifiedOptions', formData.car_modified_ind) }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{ getOptionName('modifiedOptions', oldForm.car_modified_ind) }}</span>
            <span class="color-success">{{ getOptionName('modifiedOptions', formData.car_modified_ind) }}</span>
          </span>
        </div>
      </section>
      <section v-else>
        <div
          class="tr">
          <span>Permitted Gross Vehicle Weight</span>
          <span v-if="formData.tonnage === oldForm.tonnage">{{ formData.tonnage }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{ oldForm.tonnage }}</span>
            <span class="color-success">{{ formData.tonnage }}</span>
          </span>
        </div>
        <div
          class="tr">
          <span>Seating Capacity ( excl. driver)</span>
          <span v-if="formData.no_of_seats== oldForm.no_of_seats">{{ formData.no_of_seats }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{ oldForm.no_of_seats }}</span>
            <span class="color-success">{{ formData.no_of_seats }}</span>
          </span>
        </div>
        <div class="tr">
          <span>Chassis Number</span>
          <span v-if="formData.chasis_no === oldForm.chasis_no">{{ formData.chasis_no }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{ oldForm.chasis_no }}</span>
            <span class="color-success">{{ formData.chasis_no }}</span>
          </span>
        </div>
        <div class="tr">
          <span>Engine Number</span>
          <span v-if="formData.engn_no === oldForm.engn_no">{{ formData.engn_no }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{ oldForm.engn_no }}</span>
            <span class="color-success">{{ formData.engn_no }}</span>
          </span>
        </div>
        <div
          class="tr">
          <span>Will the vehicle be used by third party for carrying goods for reward?</span>
          <span
            v-if="formData.use_carrying_profit_ind === oldForm.use_carrying_profit_ind"
            class="red">{{ getOptionName('yesNoOptions', formData.use_carrying_profit_ind) }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{ getOptionName('yesNoOptions', oldForm.use_carrying_profit_ind) }}</span>
            <span class="color-success">{{ getOptionName('yesNoOptions', formData.use_carrying_profit_ind) }}</span>
          </span>
        </div>
        <div class="tr">
          <span>Is there any modification in the above vehicle</span>
          <span
            v-if="formData.car_modified_ind === oldForm.car_modified_ind">{{ getOptionName('modifiedOptions', formData.car_modified_ind) }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{ getOptionName('modifiedOptions', oldForm.car_modified_ind) }}</span>
            <span class="color-success">{{ getOptionName('modifiedOptions', formData.car_modified_ind) }}</span>
          </span>
        </div>
        <div class="tr">
          <span>Is the vehicle fitted with Car Camcorder?</span>
          <span v-if="formData.car_camcorder_ind === oldForm.car_camcorder_ind">{{ getOptionName('installOptions', formData.car_camcorder_ind) }}</span>
          <span
            v-else
            class="compare">
            <span class="text-line color-danger">{{ getOptionName('installOptions', oldForm.car_camcorder_ind) }}</span>
            <span class="color-success">{{ getOptionName('installOptions', formData.car_camcorder_ind) }}</span>
          </span>
        </div>

      </section>
    </span>
  </div>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'InsuredVehicleInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    oldForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {},
    }
  },
  computed: {
    ...mapState('quote', ['carModelOptions']),
    showAgreeQusetion(){
      let {company_id} = this.form
      let {prev_insurer_nm,is_same_car} = this.formData||{}
      let pre_insurance = this.globalOptions.latest_insurance_company||[]
      pre_insurance =pre_insurance.filter(item=> item.id == prev_insurer_nm)
      let result = false
      if(pre_insurance.length>0)
      {
        result =pre_insurance[0].hc_cp_id==company_id
      }
      return result&&is_same_car==1
    },
    classId() {
      return this.formData.class_id || 14
    },
    localAllOptions() {
      if(this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`]
      }
    },
    businessPurposes() {
      if(!this.localAllOptions || !this.localAllOptions.business_purposes || !this.formData.business_purposes) {
        return []
      }
      return this.localAllOptions.business_purposes.filter(item => {
        return this.formData.business_purposes.includes(item.id)
      })
    },
    oldBusinessPurposes() {
      if(!this.localAllOptions || !this.localAllOptions.business_purposes || !this.oldForm.business_purposes) {
        return []
      }
      return this.localAllOptions.business_purposes.filter(item => {
        return this.oldForm.business_purposes.includes(item.id)
      })
    },
    compareBusinessPurposes() {
      const now = this.formData.business_purposes
      const old = this.oldForm.business_purposes
      const condition1 = !now && !old
      const condition2 = !now && old
      const condition3 = now && !old
      const condition4 = old? now.length !== old.length : false
      if(condition1 || condition2 || condition3 || condition4) {
        return false
      }
      let flag = true
      for(let i = 0; i < now.length; i++) {
        if(!old.includes(now[i])) {
          flag = false
          break
        }
      }
      return flag
    },
    isElectricCar11() {
      // 電動車，避免跟之前特斯拉脫機衝突
      const { model_id } = this.formData||{}
      if(model_id) {
        const data = this.getOptionData('', model_id, this.carModelOptions)
        const { is_electric_car } = data || {}
        return is_electric_car == 1
      }
      return false
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = val
      }
    },
    'formData.brand_id': {
      immediate: true,
      deep: true,
      handler(val, old) {
        if(val && this.classId == 11) {
          this.updateCarModelOptions({
            val,
            time: new Date().getTime()
          })
        }
      }
    }
  },
  methods: {
    ...mapActions('quote', ['updateCarModelOptions']),
    getLocalAllOptionName(target, value) {
      if(this.classId == 14) {
        return this.getAllOptionName(target, value)
      } else {
        return this[`getAllOptionName${this.classId}`](target, value)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.table {
  .tr {
    .compare {
      display: flex;
      align-items: center;
      & > span {
        flex: 1;
      }
    }
  }
}
</style>
